import { EventId, PositionId } from 'common/src/generated/types';
import { isNonEmptyString } from 'common/src/util/string';
import { sortBy, uniqBy } from 'lodash-es';
import * as React from 'react';
import { usePositionsSearchQuery } from '../../generated/graphqlHooks';

interface IUsePositionsSearchOptions {
    eventId: EventId;
    hasSelected: boolean;
    nameDebounced: string;
    positionsIds: PositionId[];
}

interface IUsePositionsSearchResult {
    isLoading: boolean;
    positionsOptions: React.ReactNode;
}

export function usePositionsSearch({
    eventId,
    hasSelected,
    nameDebounced,
    positionsIds
}: IUsePositionsSearchOptions): IUsePositionsSearchResult {
    const { data, isLoading } = usePositionsSearchQuery({
        eventId,
        hasSelected,
        name: isNonEmptyString(nameDebounced) ? nameDebounced : undefined,
        positionsIds
    });
    const positions = React.useMemo(
        () =>
            sortBy(
                uniqBy(
                    (data.event?.positions.nodes ?? []).concat(
                        data.event?.selectedPositions.nodes ?? []
                    ),
                    (p) => p.id
                ),
                (p) => p.name.toLowerCase()
            ),
        [data.event]
    );
    const positionsOptions = React.useMemo(
        () =>
            positions.map((p) => (
                <option key={p.id} value={p.id}>
                    {p.name}
                </option>
            )),
        [positions]
    );

    return { positionsOptions, isLoading };
}
